import React, { useState } from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { Button, Icon, Modal, Text } from '@amzn/storm-ui';
import { exclamationTriangle, spinner } from '@amzn/storm-ui-icons';
import styled from 'styled-components';

const ContentWrapper = styled.div`
    padding-top: 8px;
    padding-left: ${({ theme }) => theme.spacing.base};
    padding-right: ${({ theme }) => theme.spacing.base};
    padding-bottom: ${({ theme }) => theme.spacing.small};
    max-width: 619px;
`;

const TextContainer = styled(Text)`
    padding-top: ${({ theme }) => theme.spacing.medium};
    padding-bottom: ${({ theme }) => theme.spacing.medium};
`;

const GrayIcon = styled(Icon)`
    color: #495566
`;

interface SecurityWarningModalProps {
    isOpen: boolean;
}

export const SecurityWarningModal: React.FC<SecurityWarningModalProps> = ({ isOpen = false }) => {
    const [bundle, isBundleLoading] = useBundle('pages.interstitial');
    const [isModalOpen, setIsModalOpen] = useState(isOpen); //use session storage here

    if (isBundleLoading) {
        return <Icon type={spinner}></Icon>
    }

    const header = bundle.getMessage('security_warning');
    const title = bundle.getMessage('sensitive_information_title');
    const text = bundle.getMessage('sensitive_information_text');
    const backBtn = bundle.getMessage('back');
    const continueBtn = bundle.getMessage('continue');

    const onContinue = () => {
        setIsModalOpen(false);
    }

    const onGoBack = () => {
        onContinue();
        window.history.back();
    }

    const Header = () => <Text> {header} </Text>
 
    const Footer = () => (
        <>
            <Button onClick={onGoBack}> {backBtn} </Button>
            <Button onClick={onContinue} primary> {continueBtn} </Button>
        </>
    )
    return (
        <>
            <Modal
                isOpen={isModalOpen}
                header={<Header />}
                footer={<Footer />}
                hasCloseButton={false}
            >
                <ContentWrapper>
                    <GrayIcon 
                        type={exclamationTriangle}
                        size="2x"
                        blockSize={false}
                    />
                    <TextContainer type="h3" > {title} </TextContainer>
                    <Text> {text} </Text>
                </ContentWrapper>
            </Modal>
        </>
    )
};
